import { FC, useState } from 'react';
import { useAdminAdmins } from 'store/admin-admins';
import { SelectFilter, SelectFilterProps } from 'components/filters';

type Props = Omit<
  SelectFilterProps<string, true>,
  'options' | 'loadingOptions' | 'asyncSearch' | 'onSearch' | 'multiple'
>;

export const AdminAdminsFilter: FC<Props> = (props) => {
  const [search, setSearch] = useState('');

  const { data: admins, isLoading } = useAdminAdmins({
    name: search,
  });

  return (
    <SelectFilter
      {...props}
      options={admins?.items.map((admin) => ({
        key: admin.id,
        label: admin.fullName,
      }))}
      loadingOptions={isLoading}
      onSearch={setSearch}
      multiple
      asyncSearch
    />
  );
};
